import { Card, CardContent } from '@material-ui/core';
import { Divider, Grid, Typography } from '@material-ui/core';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import * as React from 'react';
import Patterns from '../common/patterns';

import Pause from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrowSharp';
import ShuffleIcon from '@material-ui/icons/ShuffleSharp';
import SkipNextIcon from '@material-ui/icons/SkipNextSharp';
import StopIcon from '@material-ui/icons/StopSharp';

import './LifeInfo.css';

interface LifeInfoProps {
  events: any,
}

const LifeInfo = (props: LifeInfoProps) =>
  <div className="padded">
    <Card raised={true}>
      <CardContent>

        <Typography variant="headline" color="default">
          Patterns
        </Typography>

        <Grid container={true} spacing={8}
          alignContent="center" alignItems="center">

          {Object.keys(Patterns).map(key => (
            <Grid item={true} xs={true} key={key}>
              <Button size="small" variant="raised"
                onClick={props.events.patterns[key]}> {key}
              </Button>
            </Grid>
          ))}

        </Grid>
      </CardContent>

      <Divider />

      <CardContent>
        <Table>
          <TableBody>

            <TableRow>
              <TableCell padding="checkbox"><ShuffleIcon /></TableCell>
              <TableCell>Populate the grid randomly</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox"><PlayArrowIcon /></TableCell>
              <TableCell>Start continuous cycling</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox"><SkipNextIcon /></TableCell>
              <TableCell>Advances life by one cycle and stops</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox"><Pause /></TableCell>
              <TableCell>Suspends life</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox"><StopIcon /></TableCell>
              <TableCell>Stops life and clears the grid</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox">
                <Button size="small" variant="raised">Pattern</Button>
              </TableCell>
              <TableCell>Place a pattern on the grid</TableCell>
            </TableRow>

            <TableRow>
              <TableCell padding="checkbox">
                <div style={{
                  backgroundColor: "black",
                  width: "2mm", height: "2mm" }}>&nbsp;
                </div></TableCell>
              <TableCell>Click/tap individual cells to set/reset them</TableCell>
            </TableRow>

          </TableBody>
        </Table>

        <p>Read the <a href=
          "https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life#Rules">
          Rules of Life</a>.</p>
      </CardContent>
    </Card>
  </div>;

export default LifeInfo;



// WEBPACK FOOTER //
// ./src/components/LifeInfo.tsx